module.exports = __webpack_public_path__ + "img/ascend_gold18.675cd2f6.png";